import '../App.css';
import { useState, useEffect } from "react";

function SeasonWinners({ seasons }) {

    const [seasonIndex, setSeasonIndex] = useState(0);

    useEffect(() => {
        if (seasons && seasons.length > 0) {
            setSeasonIndex(seasons.length - 1); // start on newest season
        }
    }, [seasons]);

    if (!seasons || seasons.length === 0) return null;

    const season = seasons[seasonIndex];

    const goPrev = () => {
        if (seasonIndex > 0) {
            setSeasonIndex(seasonIndex - 1);
        }
    };

    const goNext = () => {
        if (seasonIndex < seasons.length - 1) {
            setSeasonIndex(seasonIndex + 1);
        }
    };

    return (
        <div className="season-winners">

            <div className="season-pagination">
                <button onClick={goPrev} disabled={seasonIndex === 0}>
                    ← Prev
                </button>

                <div className="season-title">{season.season}</div>

                <button
                    onClick={goNext}
                    disabled={seasonIndex === seasons.length - 1}
                >
                    Next →
                </button>
            </div>

            <div className="winner-first">
                <div className="trophy">🏆</div>
                <div className="winner-name">{season.first}</div>
                <div className="winner-rating">{season.first_rating}</div>
            </div>

            <div className="winner-row">

                <div className="winner-second">
                    <div className="trophy">🥈</div>
                    <div>{season.second}</div>
                    <div>{season.second_rating}</div>
                </div>

                <div className="winner-third">
                    <div className="trophy">🥉</div>
                    <div>{season.third}</div>
                    <div>{season.third_rating}</div>
                </div>

            </div>

        </div>
    );
}

export default SeasonWinners;